import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import { FrontDirectivesModule } from '../../directives/directives.module';
import { FrontPipesModule } from '../../pipes/pipes.module';
import {ComponentsModule} from '../../components/components.module';
import {HelpView} from './help.view';
import {FaqView} from './faq/faq.view';
import {FaqNodeView} from './faqNode/faqNode.view';

@NgModule({
    declarations: [
        HelpView,
        FaqView,
        FaqNodeView
    ],
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        IonicModule,
        ComponentsModule,
        FrontDirectivesModule,
        FrontPipesModule
    ]
})
export class HelpModule {

}
